import { Component, inject, input } from '@angular/core';
import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { OfferList } from '@/_store/offers/offers.types';
import { PipesModule } from '@/modules/shared/pipes/pipes.module';
import { MainService } from '@/main/services/main.service';
import { ObserveWidthDirective } from '@/common/directives/observe-width.directive';
import { OffersFacade } from '@/_store/offers/offers.facade';

@Component({
	selector: 'app-offer-box-mobile-highlight',
	templateUrl: './offer-box-mobile-highlight.component.html',
	standalone: true,
	imports: [NgOptimizedImage, PipesModule, ObserveWidthDirective, AsyncPipe],
})
export class OfferBoxMobileHighlightComponent {
	readonly offer = input.required<OfferList>();

	readonly mainService = inject(MainService);
	readonly offersFacade = inject(OffersFacade);
}
